import { Component, OnInit, Input, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { UserRoleService } from 'src/app/services/user-role.service';

@Component({
  selector: 'app-job-day',
  templateUrl: './job-day.component.html',
  styleUrls: ['./job-day.component.scss']
})
export class JobDayComponent implements OnInit {

  @Input('job') jobs;
  user: any;
  singleJob: any;
  constructor(private changeDetector: ChangeDetectorRef, public router: Router, public _userRoleService: UserRoleService) { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    // console.log("changes in job-day", this.jobs)
    this.changeDetector.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log("CHANGES IN JOB DAY", changes.jobs);

    if (changes && changes.jobs && changes.jobs.currentValue) {
      this.jobs = changes.jobs.currentValue
      // if (this.jobs && this.jobs.length) console.log("changes in job-day", changes, this.jobs)
      this.changeDetector.detectChanges();
    }
  }

  // goToCourse(job) {
  //   console.log("job in profile component ------->  ", job);
  //   let navigationExtras: NavigationExtras = {
  //     state: {
  //       job: job
  //     }
  //   };
  //   this.router.navigateByUrl('/materials/' + job.course.templateId, navigationExtras);
  // }

  async goToCourse(job) {
    console.log("job ??  ", job);
    // let navigationExtras: NavigationExtras = {
    //   state: {
    //     job: job
    //   }
    // };
    this.singleJob = job
    let userRole = await this.getUserRole()
    console.log("userRole !!!!  ", userRole);
    let param = {
      userRole: userRole
    }
    this.router.navigate(['/materials/' + job.course.templateId], { queryParams: param })
    // this.router.navigateByUrl('/materials/' + job.course.templateId + "userRole=" + userRole);

  }

  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.singleJob.instructors, 'job');
    console.log("getRole ?? ", getRole);
    if (getRole.isAdmin) return 0
    else if (getRole.isLearner) return 3
    else if (getRole.isClient) return 4
    else if (getRole.isTrainer) return 1
    else if (getRole.isIQA) return 2

  }

}
